
import { Vue, Component } from "vue-property-decorator";

@Component
export default class Banner extends Vue {
  heroBanner: any = require("@/assets/images/hero-banner.jpeg");
}
